import { connect } from 'react-redux';
import RouteDialog from './route-dialog';
import {closeRouteDialog } from '../../reducers/order.reducers';

const mapStateToProps = state => ({
  open: !!state.orders.openRouteDialog,
  routestops: state.orders.routestops,
  orders: state.orders.orders,
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeRouteDialog()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteDialog);
